import { color } from 'asserts/styles/colors';
import styled from 'styled-components';
import SignLayout from 'layout/JoinLayout';
import DefaultButton from 'components/button/DefaultButton';

import { ReactComponent as IconWindow } from 'asserts/icons/ic_window_join.svg';
import { ReactComponent as IconSearch } from 'asserts/icons/ic_search_join.svg';
import { ReactComponent as IconData } from 'asserts/icons/ic_data_join.svg';
import { useNavigate } from 'react-router-dom';
import { useSetAtom } from 'jotai';
import modalInformationAtom from 'atom/modalInformationAtom';

const JoinInfo = () => {
  const navigate = useNavigate();

  const setModalInformation = useSetAtom(modalInformationAtom);

  const handleClickJoinPage = () => {
    if (true) {
      setModalInformation({
        type: 'UNITEDMEMBER_JOIN',
        handleClickRightBtn: () => {
          navigate('/login');
        }
      });
    }
  };

  return (
    <SignLayout text="엑스바디 서비스 이용을 위해 회원가입을 해주세요.">
      <Wrapper>
        <DefaultButton text="회원가입" onClick={handleClickJoinPage} size="large" type="primary" />
        <IconWrappaer>
          <div>
            <IconWindow />
            <p>엑스바디 프로그램 기본 이용권</p>
          </div>
          <div>
            <IconSearch />
            <p>프로그램을 이용한 검사 서비스 일체</p>
          </div>
          <div>
            <IconData />
            <p>피검자(고객) 데이터 관리, 검사 데이터 & 리포트 관리</p>
          </div>
        </IconWrappaer>
      </Wrapper>
    </SignLayout>
  );
};

export default JoinInfo;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
`;

const IconWrappaer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  div {
    display: flex;
    gap: 16px;
    align-items: center;
  }

  p {
    color: ${color.gray600};
    font-size: 18px;
    font-weight: 500;
    line-height: 22px;
  }
`;
